import { progressAnatomy as parts } from '@chakra-ui/anatomy';
import { getColor } from '@chakra-ui/theme-tools';
const baseStyleTrack = ({ colorScheme: c }) => {
    return {
        bg: `${c}.200`,
        borderRadius: '1.25rem',
    };
};
const filledStyle = ({ colorScheme: c, theme, isIndeterminate, }) => {
    const bgColor = `${c}.500`;
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${getColor(theme, bgColor)} 50%,
    transparent 100%
  )`;
    return {
        ...(isIndeterminate ? { bgImage: gradient } : { bgColor }),
    };
};
const baseStyleFilledTrack = (props) => {
    return {
        transitionProperty: 'all',
        transitionDuration: 'slow',
        ...filledStyle(props),
    };
};
const baseStyle = (props) => ({
    track: baseStyleTrack(props),
    filledTrack: baseStyleFilledTrack(props),
});
const sizes = {
    xl: {
        track: { h: '1.5rem' },
    },
};
export const Progress = {
    baseStyle,
    parts: parts.keys,
    sizes,
    defaultProps: {
        size: 'md',
        colorScheme: 'brand.primary',
    },
};
